/* eslint-disable no-unused-vars */
import { ChartNoDataIcon } from 'assets/icons';
import styled from 'styled-components';
import { Palette } from 'config';

export const NoDataToDisplay = ({ message }) => {
  return (
    <Box>
      <ErrorWrap>
        <ChartNoDataIcon />
        <Text>{message || 'No data'}</Text>
      </ErrorWrap>
    </Box>
  );
};

export const ErrorWrap = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 152px;
`;

export const Text = styled.div`
  margin: 0;
  padding: 0;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  line-height: 16px;
`;
